module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Les_Ponts-de-Martel-807e7faba8657947af95dfa32d33832e.png";